const http = require('../../util/http_utils');
const config = require('../../config');

const eventData = {
    'event_type': 'media.watch',
    'event_params': {
        'user_id': null,
        'date': null,
        'origin': 'web',
        'media_details': {
            'action': null,
            'value': null,
            'media_id': null,
            'module_id': null
        }
    }
};
// FIXME Move this to configuration files
const playbackPercentages = [0, 0.25, 0.5, 0.75, 0.9];
let playbackTimes = null;
let duration = null;
let previousSecond = null;

function calculateTimes(duration) {
    if (duration) {
        playbackTimes = playbackPercentages.map(function(percentage) {
            return Math.floor(duration * percentage);
        });
    }
}

function setDuration(newDuration) {
    duration = newDuration;
    calculateTimes(newDuration);
}

function calculatePlayedPercentage(currentTime = 0, totalDuration = 1) {
    return (currentTime / totalDuration).toFixed(2);
}

class RecommendationEngine {

    constructor(configuration) {
        this.contentId = configuration.contentId;
        this.userId = configuration.userId;
        this.moduleId = configuration.moduleId;
        this.adapter = configuration.adapter;
        this.sessionToken = configuration.sessionToken;

        this.userEventsEndpoint = `${config.recEngineUrl}users/${this.userId}/event`;

        setDuration(this.adapter.getDuration());

        return this;
    }

    sendEvent(type = 'watch', value) {

        let playbackTimeValue = value !== undefined ? value : calculatePlayedPercentage(this.adapter.getCurrentTime(), duration);

        // FIXME Set the constant values in constructor to avoid repeating logic on each event submission
        eventData.event_params.user_id = this.userId;
        eventData.event_params.date = new Date().getTime();
        eventData.event_params.media_details.action = type;
        eventData.event_params.media_details.value = playbackTimeValue.toString();
        eventData.event_params.media_details.media_id = this.contentId;
        eventData.event_params.media_details.module_id = this.moduleId;

        const requestConfig = {
            uri: this.userEventsEndpoint,
            body: eventData,
            headers: {
                Authorization: 'Bearer ' + this.sessionToken,
                'client-type': 'website',
                'xtype': 'portal'

            }
        };
        http.post(requestConfig, result => console.log('response received'));
    }

    monitorPlayback(event) {
        let currentSecond = Math.round(event.time);
        if (currentSecond !== previousSecond) {
            if (!duration) {
                setDuration(this.adapter.getDuration());
            }
            // FIXME Probably this.adapter.getCurrentTime() can be replaced by currentSecond
            let foundPlaybackTime = playbackTimes.indexOf(Math.round(this.adapter.getCurrentTime()));
            if (foundPlaybackTime > -1) {
                this.sendEvent('watch', playbackPercentages[foundPlaybackTime]);
            }
            previousSecond = currentSecond;
        }
    }
}

module.exports = RecommendationEngine;



// WEBPACK FOOTER //
// ./src/modules/recommendation_engine/recommendation_engine.js